/* Scoped layout only: no Ant Design reset or overrides on the matrix. */
.antd-filter-panel .antd-search {
  flex: 1 1 230px;
  max-width: 200px;
}
.antd-filter-field {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.antd-filter-field > span {
  font-size: 12px;
  color: #81899b;
  white-space: nowrap;
}
.antd-filter-field .ant-select {
  width: 108px;
}
.antd-filter-field .antd-brand-select {
  width: 190px;
}
.antd-filter-field .antd-country-select, .antd-filter-field .antd-ram-rom-select {
  width: 132px;
}
.antd-filter-panel .launch-range-picker {
  width: 280px;
  min-width: 0;
  max-width: 100%;
}
.antd-filter-panel .antd-reset {
  margin-left: auto;
}
.antd-filter-panel .range-row .ant-input-number {
  width: 112px;
}
.antd-brand-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  border-bottom: 1px solid #eff0f5;
  padding: 6px 8px;
  font-size: 12px;
}
.antd-brand-actions > span {
  margin-right: auto;
  color: #81899b;
}
@media (max-width: 900px) {
  .antd-filter-panel .antd-search {
    max-width: none;
    flex-basis: 100%;
  }
}
@media (max-width: 560px) {
  .antd-filter-panel .antd-filter-field {
    gap: 6px;
  }
  .antd-filter-panel .antd-brand-select {
    width: 150px;
  }
  .antd-filter-panel .antd-country-select {
    width: 108px;
  }
  .antd-filter-panel .launch-range-picker {
    width: 100%;
  }
  .antd-filter-panel .launch-inline .setting-label {
    flex-basis: 100%;
  }
  .antd-filter-panel .secondary-filter-row .ant-select {
    width: 82px;
  }
  .antd-filter-panel .antd-reset {
    margin-left: 0;
  }
  .antd-filter-panel .range-row .ant-input-number {
    width: 94px;
  }
}
